import { render, staticRenderFns } from "./QuizConfig.vue?vue&type=template&id=67d85286"
import script from "./QuizConfig.vue?vue&type=script&lang=js"
export * from "./QuizConfig.vue?vue&type=script&lang=js"
import style0 from "./QuizConfig.vue?vue&type=style&index=0&id=67d85286&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports